import React from 'react';

// Shared building blocks for the onsite form (Page 1) and the review page (Page 2).

// Section accent colours (passed as props, so they live in JS rather than CSS).
export const GOLD = '#a67c2c';
export const RED  = '#c0392b';

export const Field = ({ label, required, children, span = 1 }) => (
  <div style={{ gridColumn: `span ${span}` }}>
    <label className="onsite-form-field__label">
      {label}{required && <span className="onsite-form-field__required">*</span>}
    </label>
    {children}
  </div>
);

// Inline validation message shown under a field.
export const FieldError = ({ children }) => (
  <p className="onsite-form-sig-error">
    <i className="fa-solid fa-triangle-exclamation" />
    {children}
  </p>
);

export const Section = ({ icon, title, subtitle, accent, children, id, action }) => (
  <section id={id} className="onsite-form-section">
    <div className="onsite-form-section__header">
      <div className="onsite-form-section__icon-wrap" style={{ background: `${accent}18` }}>
        <i className={`fa-solid ${icon}`} style={{ fontSize: '16px', color: accent }} />
      </div>
      <div>
        <h3 className="onsite-form-section__title">{title}</h3>
        {subtitle && <p className="onsite-form-section__subtitle">{subtitle}</p>}
      </div>
      {action && <div className="onsite-form-section__action">{action}</div>}
    </div>
    <div className="onsite-form-section__body">{children}</div>
  </section>
);

export const HeroBanner = ({ firstName, lastName, logo }) => {
  const now = new Date();
  const dateStr = now.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  const timeStr = now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  return (
    <div className="onsite-form-hero">
      <svg className="onsite-form-hero__pattern" viewBox="0 0 200 200" aria-hidden="true">
        <circle cx="100" cy="100" r="90" fill="none" stroke="#fff" strokeWidth="1"/>
        {Array.from({ length: 32 }).map((_, i) => {
          const a = (i / 32) * Math.PI * 2;
          return <circle key={`o-${i}`} cx={100 + Math.cos(a) * 70} cy={100 + Math.sin(a) * 70} r="3" fill="#fff"/>;
        })}
        {Array.from({ length: 24 }).map((_, i) => {
          const a = (i / 24) * Math.PI * 2;
          return <circle key={`m-${i}`} cx={100 + Math.cos(a) * 45} cy={100 + Math.sin(a) * 45} r="2.5" fill="#fff"/>;
        })}
        {Array.from({ length: 12 }).map((_, i) => {
          const a = (i / 12) * Math.PI * 2;
          return <circle key={`i-${i}`} cx={100 + Math.cos(a) * 22} cy={100 + Math.sin(a) * 22} r="2" fill="#fff"/>;
        })}
      </svg>
      <div className="onsite-form-hero__content">
        <div className="onsite-form-hero__top">
          <span className="onsite-form-hero__eyebrow">On-site Registration</span>
        </div>
        <h2 className="onsite-form-hero__welcome">
          Welcome, <span className="onsite-form-hero__name">{firstName} {lastName}</span>
        </h2>
        <div className="onsite-form-hero__date">
          <i className="fa-solid fa-calendar" style={{ marginRight: '7px' }} />{dateStr} · {timeStr}
          <span className="onsite-form-hero__badge" style={{ marginLeft: '12px' }}>
            <i className="fa-solid fa-flag" /> 2028 Los Angeles Olympics · Golf
          </span>
        </div>
      </div>
      <div className="onsite-form-hero__logo-card">
        <img src={logo} alt="IGF — International Golf Federation" />
      </div>
    </div>
  );
};
